<template>
	<div id="d21-app">
		<router-view v-if="isReady"></router-view>
	</div>
</template>

<script>
	import hub from "./scripts/_hub";
	export default {
		name: "d21-app",
		computed: {
			isReady() {
				return hub.isReady();
			}
		},
		methods: { },
		mounted() { }
	};
</script>